import { SiteIdOverrideConfig } from "stores/wizard/config";
import { defaultLocationValue_en } from "../../staticConfigs/thirdPartyPackage/thirdPartyPackageConfig";
import { defaultDestinationsSiteId72, defaultOriginsSiteId72 } from "./siteId72";

// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
export const siteId72_en_GB: SiteIdOverrideConfig = {
  package: {
    navigation: {
      tabTitleToken: "wizard.package.tab.title.variant.1.label",
    },
  },
  thirdPartyPackage: {
    origins: [defaultLocationValue_en, ...defaultOriginsSiteId72],
    destinations: [defaultLocationValue_en, ...defaultDestinationsSiteId72],
  },
};
